import React from "react";
import PropTypes from "prop-types";
import { isFunction, isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import CovertButton from "@cayuse/shared-react.components.covert-button";

import styles from "./styles.css";

// NOTE: Keyboard interactions and internal focus are managed in the FacetedSearchBar component.
const FacetMenu = React.forwardRef(({
	facets,
	isOpen,
	onSelect,
	menuId,
	baseSearchbarId,
	currentlySelectedItem,
	isLoading = false,
	onFocus,
	onBlur,
}, ref) => {
	const hasFacets = isNonEmptyArray(facets);

	const handleSelection = facet => {
		if (isFunction(onSelect)) {
			onSelect(facet);
		}
	};

	return (
		<div data-component="FacetedSearchBar\FacetMenu"
			 className={`${styles.facetMenu} facetMenu ${isOpen ? styles.open : ""}`}
			 ref={ref}
		>
			<ul id={menuId} role="listbox" className={styles.facetList}>
				{ isLoading ?
					<div>Loading...</div>
					: hasFacets && facets.map((facet, k) => {
						const menuItemId = `${baseSearchbarId}-menuitem-${facet.key}-${k}`;
						const ariaSelectedAttribute = menuItemId === currentlySelectedItem ? { "aria-selected": "true" } : {};
						const ariaLabelAttribute = { "aria-label": `Add ${facet.text} column filter` };

						return (
							<li
								{...ariaSelectedAttribute}
								{...ariaLabelAttribute}
								role="option"
								id={menuItemId}
								key={`facet-${facet.key}-${k}`}
							>
								<CovertButton
									className={styles.facetButton}
									onClick={() => {
										onFocus();
										handleSelection(facet)
										onBlur();
									}}
									tabIndex="-1"
								>
									{facet.text}
								</CovertButton>
							</li>
						);
					})}
			</ul>
		</div>
	);
});

FacetMenu.propTypes = {
	menuId: PropTypes.string,
	baseSearchbarId: PropTypes.string,
	currentlySelectedItem: PropTypes.string,
	facets: PropTypes.arrayOf(PropTypes.shape({
		key: PropTypes.string,
		text: PropTypes.string,
	}))
};

export default FacetMenu;
